<template>
  <!-- Modal -->
  <div class="modal fade" id="messageModal" ref="rMessageModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body  p-0">
          <div class="alert alert-success mb-0" role="alert">
            <h4 class="alert-heading">Hi {{memberNickName}},</h4>
            <p>Your message has been sent successfully.</p>
            <p>Thank you</p>
            <hr>
            <p class="mb-0">Our Client Services team will answer your inquiry as soon as possible..</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">CLOSE {{count+1}}s</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

    export default {
        name: "MessageTips",
        data(){
          return {
            memberNickName:'',
            count: '',
            timer: null
          }
        },
        methods:{
          setTimer(){
            const TIME_COUNT = 4;
            if (!this.timer) {
              this.count = TIME_COUNT;
              $("#messageModal").modal("show")
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  $("#messageModal").modal("hide")
                  clearInterval(this.timer);
                  this.timer = null;

                }

              }, 1000)

            }

          },
          setName(name){
             this.memberNickName =name
          }
        }
    }
</script>

<style scoped>

</style>
